import { fetchApiKeysPaged } from '../../../../api/apiKey';

const createValidateKeyName = (intl: any) => {
  return async (_rule?: any, keyName?: string): Promise<void> => {
    if (!keyName || keyName.trim() === '') {
      return Promise.resolve();
    }

    // Check for restricted special characters: # % ? / " \
    const restrictedChars = /[#%?/"\\]/;
    if (restrictedChars.test(keyName)) {
      return Promise.reject(
        new Error(
          intl.formatMessage({
            id: 'ApiKeys.modal.input.validation.keyName',
          }),
        ),
      );
    }
  };
};

interface DuplicateKeyNameValidatorOptions {
  ignoreApiKeyId?: string;
}

interface APIKeyValidatorRecord {
  id?: string;
  name?: string;
  keyName?: string;
  name1?: string;
}

const checkDuplicateKeyName = (
  intl: any,
  options?: DuplicateKeyNameValidatorOptions,
) => {
  return async (_rule?: any, keyName?: string): Promise<void> => {
    try {
      if (!keyName?.trim()) {
        return Promise.resolve();
      }
      const normalizedName = keyName.trim().toLowerCase();
      const { data } = await fetchApiKeysPaged(
        `&_page=1&_size=1000&name=${encodeURIComponent(keyName.trim())}`,
      );

      if (!data?.result?.length) {
        return Promise.resolve();
      }

      const isKeyNameExist = data.result.some(
        (apiKey: APIKeyValidatorRecord) => {
          if (options?.ignoreApiKeyId && apiKey.id === options.ignoreApiKeyId) {
            return false;
          }

          const existingName = (
            apiKey.name ||
            apiKey.keyName ||
            apiKey.name1 ||
            ''
          ).trim();

          return existingName.toLowerCase() === normalizedName;
        },
      );

      if (isKeyNameExist) {
        const duplicateSuffix = intl
          .formatMessage({
            id: 'ApiKeys.modal.input.validation.keyAlreadyExists',
          })
          .trim();

        return Promise.reject(
          new Error(`${keyName.trim()} ${duplicateSuffix}`),
        );
      }

      return Promise.resolve();
    } catch {
      return Promise.reject(
        new Error(
          intl.formatMessage({
            id: 'ApiKeys.modal.input.validation.failedToValidateKeyName',
          }),
        ),
      );
    }
  };
};

export { createValidateKeyName, checkDuplicateKeyName };
